import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Axios instance with credentials for cookies
export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const publishingApi = {
  listBooks: () => http.get("/publishing/books").then(r => r.data),
  getBook: (slug) => http.get(`/publishing/books/${slug}`).then(r => r.data),
  signupEmail: (email) => http.post("/publishing/signup", { email }).then(r => r.data),
  submitInquiry: (payload) => http.post("/publishing/inquiry", payload).then(r => r.data),
};

export const authApi = {
  me: () => http.get("/auth/me").then(r => r.data),
  register: (payload) => http.post("/auth/register", payload).then(r => r.data),
  login: (email, password) => http.post("/auth/login", { email, password }).then(r => r.data),
  logout: () => http.post("/auth/logout").then(r => r.data),
  forgotPassword: (email) => http.post("/auth/forgot-password", { email }).then(r => r.data),
  resetPassword: (token, new_password) => http.post("/auth/reset-password", { token, new_password }).then(r => r.data),
};

export const libraryApi = {
  access: () => http.get("/library/access").then(r => r.data),
};

export const readerApi = {
  preview: (slug) => http.get(`/reader/${slug}/preview`).then(r => r.data),
  fullPages: (slug) => http.get(`/reader/${slug}/pages`).then(r => r.data),
};

export const paymentsApi = {
  checkout: (lookup_key) => http.post("/payments/checkout", {
    lookup_key,
    origin_url: window.location.origin,
  }).then(r => r.data),
  status: (session_id) => http.get(`/payments/status/${session_id}`).then(r => r.data),
};
